import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Services from "../pages/services/page";
import ServiceDetail from "../pages/services/detail/page";
import Orders from "../pages/orders/page";
import Help from "../pages/help/page";
import Auth from "../pages/auth/page";
import Profile from "../pages/profile/page";
import Wallet from "../pages/wallet/page";
import Affiliate from "../pages/affiliate/page";
import Invite from "../pages/invite/page";
import Settings from "../pages/settings/page";
import Recharge from "../pages/recharge/page";
import PaymentBinding from "../pages/payment-binding/page";
import Withdraw from "../pages/withdraw/page";
import Notifications from "../pages/notifications/page";
import SearchResults from "../pages/search/results/page";
import OrderResults from "../pages/orders/results/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/services",
    element: <Services />,
  },
  {
    path: "/services/:slug",
    element: <ServiceDetail />,
  },
  {
    path: "/orders",
    element: <Orders />,
  },
  {
    path: "/orders/:orderNo/results",
    element: <OrderResults />,
  },
  {
    path: "/help/how-to-order",
    element: <Help />,
  },
  {
    path: "/help/how-to-pay",
    element: <Help />,
  },
  {
    path: "/help/how-to-view-result",
    element: <Help />,
  },
  {
    path: "/help/referral",
    element: <Help />,
  },
  {
    path: "/help",
    element: <Help />,
  },
  {
    path: "/login",
    element: <Auth />,
  },
  {
    path: "/register",
    element: <Auth />,
  },
  {
    path: "/account",
    element: <Profile />,
  },
  {
    path: "/wallet",
    element: <Wallet />,
  },
  {
    path: "/affiliate",
    element: <Affiliate />,
  },
  {
    path: "/invite",
    element: <Invite />,
  },
  {
    path: "/settings",
    element: <Settings />,
  },
  {
    path: "/recharge",
    element: <Recharge />,
  },
  {
    path: "/payment-binding",
    element: <PaymentBinding />,
  },
  {
    path: "/withdraw",
    element: <Withdraw />,
  },
  {
    path: "/notifications",
    element: <Notifications />,
  },
  {
    path: "/search/results",
    element: <SearchResults />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
